<template>
  <div class="schedule-details" data-title="申请流程">
    <!-- 进度条 -->
    <div class="schedule-content">
      <p class="title">
        商家申请进度
      </p>
      <div class="progress-bar">
        <img src="../../assets/images/partner-img/14.png" alt="">
      </div>
    </div>
    <!-- 申请人信息 -->
    <div class="applicant-information">
      <p>
        经营者：林灏
      </p>
      <p>
        名称：鲜有家科技有限公司
      </p>
      <p>
        社会统一信用代码：NS45891133258
      </p>
      <p>
        创建时间:2020年06月02日 15:40
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  }
}
</script>

<style lang="less" scoped>
  .schedule-details{
    width: 7.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/partner-img/bag@2x.png');
    background-size: 100% 100%;
    // 进度
    .schedule-content{
      width: 7.1rem;
      height: 5rem;
      background: #fff;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      .title{
        font-size: 0.3rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: #212121;
        margin-top: .6rem;
        margin-left: .51rem;
        line-height: .3rem;
      }
      .progress-bar{
        img{
          width: 1.43rem;
          height: 2.93rem;
          margin-top: .55rem;
          margin-left: .5rem;
        }
      }
    }
    // 申请人信息
    .applicant-information{
      width: 7.1rem;
      height: 2rem;
      background: #fff;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      p{
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #A7A7A7;
        line-height: .5rem;
        margin-left: .39rem;
      }
    }
  }
</style>